import { render, staticRenderFns } from "./permissionSetting.vue?vue&type=template&id=1f3b194a&scoped=true"
import script from "./permissionSetting.vue?vue&type=script&lang=js"
export * from "./permissionSetting.vue?vue&type=script&lang=js"
import style0 from "./permissionSetting.vue?vue&type=style&index=0&id=1f3b194a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b194a",
  null
  
)

export default component.exports